export default "__VITE_ASSET__9PSZNkui__"